
import util from './util'
import NProgress from 'nprogress'//页面顶部进度条

export default {
    methods: {
        loadFn(key){
            let _self = this
            return function (flag) {
                _self[key] = flag
            }
        },
        progressFn(flag){
            if(flag){
                NProgress.start();
            }else{
                NProgress.done();
            }
        },
        formatDate(row, column){
            if (row[column.property]) {
                return util.date.format(row[column.property], "yyyy-MM-dd")
            } else {
                return ""
            }
        },
        formatDate2(row, column){
            if (row[column.property]) {
                return util.date.format(row[column.property], "yyyy-MM-dd hh:mm:ss")
            } else {
                return ""
            }
        },
        //枚举转换
        formatBoolean(yes,no) {
            return function (row, column) {
                return (row[column.property] === 1 || row[column.property]===true) ? yes:no
            }
        },
        //下拉或多列表
        formatByOptions(options) {
            return function (row, column) {
                return options[row[column.property]]
            }
        },
        //固定单位
        formatUnitSuf(suffix) {
            return function (row, column) {
                return row[column.property] + suffix
            }
        },
        //通过别的字段加单位
        formatUnitByFiled(fieldName) {
            return function (row, column) {
                return row[column.property] + row[fieldName]
            }
        }
    },
    mounted(){

    }
}


// WEBPACK FOOTER //
// ./src/common/mixin.js